module.exports = __webpack_public_path__ + "media/images/phone-843b53d04dc3d78d04176d5d01816052.svg";